/* -------------------------------------------------------------------------------------
Vuex module to manage type data

Main components
---------------
mutations:
- SET_TYPES: set the types array in vuex state

actions:
- fetchTypes: Gets all types from the API and pushes them to the store

getters:
- grdTypes: return types for usage in grades
- segTypes: return types for usage in segments
- trkTypes: return types for usage tracks
- trkSubtypes: return types for usage tracks
- waypTypes: return types for usage waypoints

---------------------------------------------------------------------------------------*/

// import tourdb library
import ApiService from '@/services/ApiService.js'

export const namespaced = true

export const state = {
  types: []
}

export const mutations = {
  SET_TYPES(state, types) {
    state.types = types
  }
}

export const actions = {

  // Gets all types from the API and pushes them to the store
  fetchTypes({ commit, dispatch }) {
    ApiService.getTypes()
      .then(response => {
        commit('SET_TYPES', response.data.types)
      })

      // Error handling
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was an error getting the types: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
  }
}

export const getters = {

  // return types for usage in grades
  grdTypes: state => {  
    let types = JSON.parse(JSON.stringify(state.types))
    return types
      .filter(types => types.usage === 'grd')
      .filter(types => types.parentId === null)
  },

  // return types for usage in segments
  segTypes: state => {
    let types = JSON.parse(JSON.stringify(state.types))
    return types
      .filter(types => types.usage === 'seg')
      .filter(types => types.parentId === null)
  },

  // return types for usage tracks
  trkTypes: state => {
    let types = JSON.parse(JSON.stringify(state.types))
    return types
      .filter(types => types.usage === 'trk')
      .filter(types => types.parentId === null)
  },

  // return types for usage tracks
  trkSubtypes: state => {  
    let types = JSON.parse(JSON.stringify(state.types))
    return types
      .filter(types => types.usage === 'trk')
      .filter(types => types.parentId !== null)
  },

  // return types for usage waypoints
  waypTypes: state => {
    let types = JSON.parse(JSON.stringify(state.types))
    return types
      .filter(types => types.usage === 'wayp')
      .filter(types => types.parentId === null)
  }
}
